import { Column, Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Ref } from 'react-hook-form/dist/types/fields';
import { RegisterOptions } from 'react-hook-form/dist/types/validator';
import { DAYS } from 'src/models/LineOfCreditModelUtils';

export interface DayPillsProps {
  selectedDays: (string | boolean | number)[];
  register: (ref: Ref | null, rules?: RegisterOptions) => void;
}

export function DayPills({
  selectedDays,
  register,
}: DayPillsProps): JSX.Element {
  return (
    <>
      {DAYS.map((day, index) => {
        const isDaySelected = selectedDays[index] !== false;

        // skip the null value
        if (!day) {
          return null;
        }

        return (
          <Column key={day} gutter={8} tablet={6} desktop={3}>
            <Stack y="x-sm">
              <Flex
                bg={isDaySelected ? 'globals.stone50' : 'untintedBackground'}
                borderRadius="33px"
                border="1px solid"
                borderColor="lightLine"
              >
                <label htmlFor={day.toLowerCase()} className="dayPill">
                  <input
                    className="dayPillCheckbox"
                    type="checkbox"
                    name={`days[${index}]`}
                    id={day.toLowerCase()}
                    value={index}
                    ref={register}
                    data-testid={`day-input-${index}`}
                  />
                  <Copy
                    variant="body"
                    fontFamily="secondary"
                    color={
                      isDaySelected ? 'invertedPrimaryText' : 'secondaryText'
                    }
                  >
                    {day}
                  </Copy>
                </label>
              </Flex>
            </Stack>
          </Column>
        );
      })}
    </>
  );
}
